var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 19,
    viewBox: "0 0 25 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1429 18V13.1429H16.381L12.3333 8.28571L8.28571 13.1429H11.5238V18H7.47619V17.9595C7.34019 17.9676 7.21067 18 7.07143 18C5.46119 18 3.91689 17.3603 2.77828 16.2217C1.63967 15.0831 1 13.5388 1 11.9286C1 8.81352 3.35571 6.27486 6.37848 5.92676C6.6435 4.54134 7.38302 3.29156 8.46982 2.39239C9.55662 1.49322 10.9228 1.00086 12.3333 1C13.7441 1.00078 15.1105 1.49307 16.1976 2.39222C17.2846 3.29137 18.0245 4.54119 18.2898 5.92676C21.3126 6.27486 23.665 8.81352 23.665 11.9286C23.665 13.5388 23.0254 15.0831 21.8868 16.2217C20.7482 17.3603 19.2039 18 17.5936 18C17.4576 18 17.3265 17.9676 17.1889 17.9595V18H13.1429Z",
    stroke: "#8C8A8A",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.ac4ea90d286359966ac905f537303826.svg";
export { ForwardRef as ReactComponent };